import { TransactionFormData } from '../types/form/transactionFormData.ts';

interface TransactionFormSlice {
    transactionFormData: TransactionFormData;
    setTransactionFormData: (data: Partial<TransactionFormData>) => void;
    resetTransactionFormData: () => void;
}

const initialTransactionFormData: TransactionFormData = {
    transactionType: null,
    drug: null,
    storageLocation: null,
    changedQuantity: null,
    remainingQuantityAccordingToUser: null,
    givenQuantity: null,
    disposedQuantity: null,
    administratedDateTime: null,
    description: null,
    medicalRecordId: null,
    patientIdentification: null,
    signature: null,
    doubleSignature: null,
    acceptSaldoMismatch: false,
    selectedSynonymId: null,
};

// The slice will manage the state for the transaction form
const createTransactionFormSlice = (set: any) => ({
    transactionFormData: initialTransactionFormData,

    // Set partial data in the transaction form state
    setTransactionFormData: (data: Partial<TransactionFormData>) =>
        set((state: { transactionFormData: TransactionFormData }) => ({
            transactionFormData: { ...state.transactionFormData, ...data },
        })),

    // Reset the entire form data to the initial state
    resetTransactionFormData: () =>
        set({ transactionFormData: initialTransactionFormData }),
});

export { createTransactionFormSlice };
export type { TransactionFormSlice, TransactionFormData };
